export default {
      id: "eye-solid-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#eye-solid",
      toString: function () {
        return this.url;
      }
    }